import React from 'react';
import { Button, Popover, Space, Typography } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { useIntl } from 'umi';
import { LeadTaskModel } from '@/typings/models/LeadTask';
import PrettyDate from '@/components/PrettyDate';

type RetiredTaskDetailsProps = {
  task: LeadTaskModel;
};

const RetiredTaskDetails: React.FC<RetiredTaskDetailsProps> = ({ task }) => {
  const intl = useIntl();

  const retireReason = intl.formatMessage({id: `taskAutomation.retire_trigger.${task.retire_reason}`, defaultMessage: task.retire_reason || ''});
  if (!task.retired_at) {
    return null;
  }

  const popoverContent = (
    <Space direction="vertical" size="small" style={{ maxWidth: 300 }}>
      <div>
        <Typography.Text strong>
          {intl.formatMessage({
            id: 'pages.tasks.retiredAt',
            defaultMessage: 'Retired At:',
          })}
        </Typography.Text>
        <br />
        <PrettyDate date={task.retired_at} />
      </div>
      {task.retire_reason && (
        <div>
          <Typography.Text strong>
            {intl.formatMessage({
              id: 'pages.tasks.retireReason',
              defaultMessage: 'Reason:',
            })}
          </Typography.Text>
          <br />
          <Typography.Text>{retireReason}</Typography.Text>
        </div>
      )}
    </Space>
  );

  return (
    <Popover
      content={popoverContent}
      trigger="hover"
      placement="topLeft"
    >
     <Button size={"small"} type={"text"} icon={<InfoCircleOutlined/>}>
       {intl.formatMessage({
         id: 'pages.tasks.retired',
         defaultMessage: 'Retired',
       })}
     </Button>
    </Popover>
  );
};

export default RetiredTaskDetails;
